export const FLAG_EVENTS_PRO_PLANS = 'events-pro-plans';

export const FLAG_PRE_EVENT_DISABLE_STAGE_FOR_WEBINAR =
  'pre-event-disable-stage-for-webinar';

export const FLAG_ENABLE_RECORDING_PAGE =
  'content-hub-enabled-org-dash-recording-page';

export const FLAG_ENABLE_RECORDING_REDIRECT =
  'content-hub-enable-org-dash-recording-editor-redirect';

export const FLAG_ENABLE_AI_CLIPS = 'content-hub-enable-ai-clips';

export const FLAG_POST_EVENT_ENABLE_CREATOR_LAB_CONSOLIDATION =
  'post-event-enable-creator-lab-consolidation';

export const FLAG_CHANGE_CONTENT_LIBRARY_DEFAULT_TAB =
  'post-event-content-library-default-tab';

export const FLAG_ENABLE_CREATOR_LAB_DISCOVERY =
  'post-event-enable-creator-lab-discovery';

export const FLAG_POST_EVENT_ENABLE_CREATOR_LAB_GA =
  'post-event-enable-creator-lab-ga';

export const FLAG_ENABLE_EDR_ANALYTICS_WITH_TRACK_AND_FLUSH =
  'post-event-enable-edr-analytics-with-track-and-flush';

export const FLAG_ENABLE_STANDALONE_STUDIO = 'enable-standalone-studio';

export const FLAG_EXTEND_AI_WRITER_TO_TEXT_INPUTS =
  'extend-ai-writer-to-text-inputs';

export const FLAG_RINGCENTRAL_CHAT_WIDGET_SCRIPT_ID =
  'rcx-chat-widget-script-id';

export const FLAG_POST_EVENT_ORG_RECORDINGS_UPLOAD =
  'post-event-org-recordings-upload';

export const FLAG_POST_EVENT_ADVANCED_EDITOR_SINGLE_RECORDING_EDIT =
  'post-event-advanced-editor-single-recording-edit';

// REMOVE_BEFORE_EDITOR_V2_RELEASE: gates the temporary V1/V2 editor toggle.
export const FLAG_ADVANCED_EDITOR_TOGGLE_SWITCH =
  'advanced-editor-toggle-switch';

export const FLAG_SLICE_CONNECTIONS_DIRECTORY_MIGRATION =
  'slice-connections-directory-migration';

export const FLAG_STUDIO_CONTENT_LIBRARY = 'studio-content-library';

export const FLAG_SALESFORCE_LIGHTWEIGHT_API = 'salesforce-lightweight-api';

export const FLAG_NEW_SALESFORCE_AUTH = 'new-auth-flow-salesforce';

export const FLAG_SALESFORCE_ECA_RECONNECTION_ENABLED =
  'salesforce-eca-reconnection-enabled';

export const FLAG_POST_EVENT_REHEARSAL_BACKUP_RECORDING_EDIT =
  'post-event-rehearsal-backup-edit';

export const FLAG_ENABLE_RECORDING_CREATOR = 'enable-recording-creator';

export const FLAG_POST_EVENT_SHOW_SALESFORCE_BANNER =
  'post-event-show-salesforce-banner';
